
import { defineComponent } from 'vue';

export default defineComponent({
  name: "Alert",
  props: {
    content: {
      type: String,
      required: true
    }
  }
})
